export function HijackingPdf() {
    const links = [
        {
            title: "Practice For HTML (UnityDoc)",
            url: "https://www.w3schools.com/html/html_quiz.asp",
        },
        // You can add more link objects in this array for future scalability.
    ];

    const buttonStyle = {
        marginLeft: '200px',
        padding: '7px',
        background: 'black',
        color: 'white',
        borderRadius: '8px',
    };

    return (
        <>
            <h1 className="html_qns_heading">
                These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 8</strong> recommended Geeks for Geeks links that you can refer to with important topics
            </h1>

            <h4 className="des_qns_html">
                1. Dive Into The <strong>Main</strong> Page <br />
                2. Start with Quizzes <br />
                3. Test Your Knowledge and attempt for better clarification
            </h4>

            {links.map((link, index) => (
                <div className="container_html_qns_links" key={index}>
                    <p className="vid" style={{ marginTop: '50px' }}>
                        **** {link.title} ****
                        <button
                            style={buttonStyle}
                            onClick={() => window.open(link.url, "_blank")}
                        >
                            Click Me
                        </button>
                    </p>
                </div>
            ))}
        </>
    );
}

export default HijackingPdf;
